import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

const PrivateRoute = ({
  element,
  allowedRoles, // Array of roles allowed to access the route
  requireManagedCourse = false, // Whether to check if the user manages the specific course
}) => {
  const { authState } = useAuthContext();
  const params = useParams();

  if (!authState?.id) {
    alert("Access denied: Please log in to access this page.");
    return <Navigate to="/" replace />;
  }

  // Ensure coursesManaged is always an array
  const { role, coursesManaged = [] } = authState;

  // Check for role-based access
  if (allowedRoles && allowedRoles.length > 0) {
    const roleAllowed = allowedRoles.includes(role);
    if (!roleAllowed) {
      alert("Access denied: You do not have permission to access this page.");
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Check if the user can manage the specific course
  if (requireManagedCourse) {
    const courseId = params.courseId ?? null;
    const isSuperAdmin = role === "admin";
    const hasAccess =
      isSuperAdmin || (courseId && coursesManaged.includes(courseId));

    if (!hasAccess) {
      alert("Access denied: You do not have permission to access this page.");
      return <Navigate to="/dashboard" replace />;
    }
  }

  return element;
};
export default PrivateRoute;
